import styled from 'styled-components';

const List = styled.ul`
    list-style-type: none;
    padding-left: 1.75em;
    margin: 0;
`
export default List;


// WEBPACK FOOTER //
// ./src/components/Footer/List.js